import { Services } from '@gscope-mfe/app-bridge';
import { Utilities } from '@gscope-mfe/app-bridge';
import memoize from 'lodash/memoize';
const { setUserPreference } = Utilities;
const { bulkUploadHistory, getNotificationConfig } = Services;
export default {
    asyncValues: memoize(getNotificationConfig),
    defaultTime: Number.MAX_SAFE_INTEGER,
    storageKey: 'lastNotification',
    mods: {
        bulkUpload({ userName }) {
            return {
                name: 'BulkUpload',

                init(notificationPreferences) {
                    for (let [key, value] of Object.entries(notificationPreferences)) {
                        global.localStorage[key] = typeof value === 'object' ? JSON.stringify(value) : value;
                    }

                    if (!global.localStorage.startTime || ['null', 'NaN'].includes(global.localStorage.startTime)) {
                        global.localStorage.startTime = 0;
                    }

                    if (
                        !global.localStorage.lastUploadTime ||
                        ['null', 'NaN'].includes(global.localStorage.lastUploadTime)
                    ) {
                        global.localStorage.lastUploadTime = -1;
                    }
                },

                onSync() {
                    const now = Date.now();
                    return setUserPreference({
                        pageName: 'notificationPreferences',
                        key: 'lastSyncTime',
                        value: now,
                    }).then(() =>
                        Object.assign(global.localStorage, {
                            lastSyncTime: now,
                        }),
                    );
                },

                onBadgeClick() {
                    const lastSyncTime = parseInt(global.localStorage.lastSyncTime, 10);
                    const lastUploadTime = parseInt(global.localStorage.lastUploadTime, 10);
                    const startTime = lastUploadTime === -1 ? lastSyncTime : lastUploadTime;
                    return setUserPreference({
                        pageName: 'notificationPreferences',
                        key: 'startTime',
                        value: startTime,
                    }).then(() =>
                        Object.assign(global.localStorage, {
                            startTime,
                        }),
                    );
                },

                async fetcher(state) {
                    try {
                        const { data } = await bulkUploadHistory(userName);

                        if (data.status !== 'OK') {
                            return [];
                        }

                        const ns = [];
                        const startTime = parseInt(global.localStorage.startTime, 10);
                        const lastUploadTime = parseInt(global.localStorage.lastUploadTime, 10);
                        let newLastUploadTime = lastUploadTime;

                        for (const h of data.payload.history.reverse()) {
                            if (h.status === 'F' || (h.status === 'S' && h.summary.total === h.summary.processed)) {
                                newLastUploadTime = h.uploadDate;
                                continue;
                            }

                            newLastUploadTime =
                                newLastUploadTime === -1 ? h.uploadDate : Math.max(newLastUploadTime, lastUploadTime);
                            break;
                        }

                        if (newLastUploadTime !== lastUploadTime) {
                            await setUserPreference({
                                pageName: 'notificationPreferences',
                                key: 'lastUploadTime',
                                value: newLastUploadTime,
                            });
                            Object.assign(global.localStorage, {
                                lastUploadTime: newLastUploadTime,
                            });
                        }

                        for (const h of data.payload.history) {
                            if (h.status === 'Q') {
                                continue;
                            }

                            const n = {
                                nId: h.transactionId,
                                timestamp: Math.max(h.uploadDate, startTime),
                            };

                            if (h.status === 'S') {
                                if (h.summary.total > h.summary.processed) {
                                    continue;
                                }

                                if (h.summary.total === 0) {
                                    n.text = `No records found in ${h.fileName}`;
                                    ns.push(n);
                                    continue;
                                }

                                n.text = `${h.fileName} processed`;
                                ns.push(n);
                                continue;
                            }

                            n.text = `Failed to process ${h.fileName}`;
                            ns.push(n);
                        }

                        return ns;
                    } catch (e) {
                        console.error(e);
                        return [];
                    }
                },

                onNotificationClick(notification) {
                    window.open(`/bulkupload/history?transactionId=${notification._nId}`);
                },
            };
        },
    },
};
